import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { useMergedInventory } from 'src/tiles/ListingTilesV2/ListingTilesV2.hooks';
import { groupCompListingsBetweenOwnListings } from 'src/tiles/ListingTilesV2/ListingTilesV2.utils';
import { getAllInPriceFromListPrice } from 'src/utils/inventoryUtils';
import { getMarketplaceSettings } from 'src/utils/userUtils';
import { Marketplace } from 'src/WebApiController';

import { useMobileListingDrawerContext } from '../MobileListingDrawerContext';

export const useCompListingTileItems = () => {
  const { loginContext } = useAppContext();

  const { selectedListing, listingPriceCalculation } =
    useMobileListingDrawerContext();

  const stubHubMkpSettings = getMarketplaceSettings(
    loginContext?.user?.activeAccount,
    Marketplace.StubHub,
    selectedListing?.officeId
  );

  const { allListingsMapped } = useMergedInventory(
    selectedListing ? [selectedListing] : [],
    listingPriceCalculation?.listingId === selectedListing?.id
      ? (listingPriceCalculation?.compListings ?? [])
      : []
  );

  const compListingTileItems = useMemo(() => {
    const floorPrice =
      (listingPriceCalculation?.cmpFlr?.amt ?? selectedListing?.procsFloor)
        ? getAllInPriceFromListPrice(
            listingPriceCalculation?.cmpFlr?.amt ?? selectedListing?.procsFloor,
            selectedListing,
            stubHubMkpSettings?.sellerFee
          )
        : undefined;
    const ceilingPrice =
      (listingPriceCalculation?.cmpCeil?.amt ?? selectedListing?.procsCeil)
        ? getAllInPriceFromListPrice(
            listingPriceCalculation?.cmpCeil?.amt ?? selectedListing?.procsCeil,
            selectedListing,
            stubHubMkpSettings?.sellerFee
          )
        : undefined;
    const listingTileItems = groupCompListingsBetweenOwnListings(
      allListingsMapped,
      floorPrice,
      ceilingPrice
    );
    return listingTileItems;
  }, [
    listingPriceCalculation?.cmpFlr?.amt,
    listingPriceCalculation?.cmpCeil?.amt,
    selectedListing,
    stubHubMkpSettings?.sellerFee,
    allListingsMapped,
  ]);

  return compListingTileItems;
};
